import { createContext } from "react"
import { DefaultDoctorInterface, DoctorInterface } from "../../doctors/types"

export interface FormDiplomsInterface {
  title: string, setTitle: (title: string) => void,
  image: File | any, setImage: (image: File | any) => void,
  faculty: string, setFaculty: (faculty: string) => void,
  type: string, setType: (type: string) => void,
  period: string, setPeriod: (period: string) => void,
  dateOfGraduation: string, setDateOfGraduation: (dateOfGraduation: string) => void,
  yearsOfSuccessfulStudy: string, setYearsOfSuccessfulStudy: (yearsOfSuccessfulStudy: string) => void,
  placeOfGraduation: string, setPlaceOfGraduation: (placeOfGraduation: string) => void,
}

export const  DefaultFormDiplomsInterface: FormDiplomsInterface = {
  title: "", setTitle: () => {},
  image: null, setImage: () => {},
  faculty: "", setFaculty: () => {},
  period: "", setPeriod: () => {},
  type: "", setType: () => {},
  dateOfGraduation: "", setDateOfGraduation: () => {},
  yearsOfSuccessfulStudy: "", setYearsOfSuccessfulStudy: () => {},
  placeOfGraduation: "", setPlaceOfGraduation: () => {},
}

export const FormDiplomsContext = createContext<FormDiplomsInterface>(DefaultFormDiplomsInterface)

export interface DiplomInterface {
  _id: string,
  doctor: DoctorInterface,
  title: string,
  image: File | any,
  faculty: string,
  period: string,
  type: string,
  dateOfGraduation: string,
  yearsOfSuccessfulStudy: string,
  placeOfGraduation: string,
}

export const DefaultDiplomInterface: DiplomInterface =  {
  _id: "",
  doctor: DefaultDoctorInterface,
  title: "",
  image: null,
  faculty: "",
  period: "",
  type: "",
  dateOfGraduation: "",
  yearsOfSuccessfulStudy: "",
  placeOfGraduation: "",
}

export interface ShowDiplomsInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddDiplom: boolean, setShowAddDiplom: (showAddDiplom: boolean) => void,
  showEditDiplom: boolean, setShowEditDiplom: (showEditDiplom: boolean) => void,
  showDeleteDiplom: boolean, setShowDeleteDiplom: (showDeleteDiplom: boolean) => void,
  selectedDiplom: DiplomInterface, setSelectedDiplom: (selectedDiplom: DiplomInterface) => void, 
}

export const DefaultShowDiplomsInterface: ShowDiplomsInterface = {
  showSuccessMsg: false, setShowSuccessMsg: () => {},
  showAddDiplom: false, setShowAddDiplom: () => {},
  showEditDiplom: false, setShowEditDiplom: () => {},
  showDeleteDiplom: false, setShowDeleteDiplom: () => {},
  selectedDiplom: DefaultDiplomInterface, setSelectedDiplom: () => {}, 
}

export const ShowDiplomsContext = createContext<ShowDiplomsInterface>(DefaultShowDiplomsInterface)
